export default __webpack_public_path__ + "static/media/pictogramBeaconEntertainment48.d97ba241.svg";